module.exports = __webpack_public_path__ + "img/agrimontana-lavorazione-marroni.bf1e3563.jpg";